import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { MainLayout } from '@/components/layout/MainLayout';
import { SingleUseTokensListPage } from '@/components/user/SingleUseTokensListPage';

export default function UserManagementTokensPage() {
    return (
        <ProtectedRoute>
            <MainLayout>
                <SingleUseTokensListPage
                    variant="user-management"
                    pageTitle="User Management Tokens"
                />
            </MainLayout>
        </ProtectedRoute>
    );
}
